<template>
  <main-layout :selectedMenu="'home'">
    <div class="do-competition contantGeek1">
      <div class="contest-wrap">
        <div class="geekBanner">
          <div class="do-banner1">
            <img
              :src="
                (language === 'zh'
                  ? matchObject.zhPcBannerImage
                  : matchObject.enPcBannerImage || matchObject.zhPcBannerImage)
                  | imageUrl
              "
              alt
            />
          </div>
          <div
            class="navList"
            id="navList"
            :style="{ background: colorString.nav.navBg }"
            v-if="
              (matchStatus !== 1 || geekList != '' || tagList.length > 1) &&
              matchObject.id !== 1031
            "
          >
            <ul>
              <li
                :class="{ selected: page === 0 }"
                @mouseover="hoverPage = 1"
                @mouseleave="hoverPage = null"
                :style="{
                  background:
                    page == 0 || hoverPage == 1
                      ? colorString.nav.hoverNav
                      : colorString.nav.NavTextCor,
                }"
                @click="togger(0)"
              >
                <router-link
                  :style="{
                    color:
                      page == 0 || hoverPage == 1
                        ? colorString.nav.hoverTextCor
                        : colorString.nav.textCor,
                  }"
                  :to="{
                    name: 'contestHome',
                    params: { contestName: contestName },
                  }"
                  >{{ $t("global.首页") }}</router-link
                >
              </li>

              <li
                @click="page = 0"
                v-for="(item, index) in language == 'zh' ? tagList : enTagList"
                :key="index"
                v-if="item.text && item.text !== '首页'"
                @mouseover="hoverPage = item.id"
                @mouseleave="hoverPage = null"
                :style="{
                  background:
                    hoverPage == item.id
                      ? colorString.nav.hoverNav
                      : colorString.nav.NavTextCor,
                }"
              >
                <a
                  href="javascript:;"
                  @click="scrollPageTo(item.id)"
                  :style="{
                    color:
                      hoverPage == item.id
                        ? colorString.nav.hoverTextCor
                        : colorString.nav.textCor,
                  }"
                  >{{ item.text }}</a
                >
              </li>
              <li
                :class="{ selected: page == item.navName }"
                @click="togger(item.navName)"
                v-if="SubpageList.length && item.navName"
                v-for="(item, index) in SubpageList"
                :key="index"
                @mouseover="hoverPage = item.navName"
                @mouseleave="hoverPage = null"
                :style="{
                  background:
                    page == item.navName || hoverPage == item.navName
                      ? colorString.nav.hoverNav
                      : colorString.nav.NavTextCor,
                }"
              >
                <router-link
                  :style="{
                    color:
                      page == 0 || hoverPage == 1
                        ? colorString.nav.hoverTextCor
                        : colorString.nav.textCor,
                  }"
                  :to="{
                    name: 'contestPage',
                    params: { contestName: contestName },
                    query: { type: index },
                  }"
                  >{{ item.navName }}</router-link
                >
              </li>
              <div v-for="(item, index) in SubpageList" :key="index">
                <li
                :class="{ selected: page == language == 'zh' ? item.zhName : item.enName || item.zhName }"
                v-if="item.type && item.type == 1"
                @mouseover="hoverPage = (language == 'zh' ? item.zhName : item.enName || item.zhName)"
                @mouseleave="hoverPage = null"
                :style="{
                  background:
                    page == (language == 'zh' ? item.zhName : item.enName || item.zhName) || hoverPage == (language == 'zh' ? item.zhName : item.enName || item.zhName)
                      ? colorString.nav.hoverNav
                      : colorString.nav.NavTextCor,
                }"
              >
                <a
                  href="javascript:;"
                  @click="scrollPageTo(contestName + '' + item.point)"
                  >{{ language == 'zh' ? item.zhName : item.enName || item.zhName}}</a
                >
              </li>
              <li
                :class="{ selected: page == language == 'zh' ? item.zhName : item.enName || item.zhName }"
                v-if="item.type && item.type == 2"
                @mouseover="hoverPage = (language == 'zh' ? item.zhName : item.enName || item.zhName)"
                @mouseleave="hoverPage = null"
                :style="{
                  background:
                    page == (language == 'zh' ? item.zhName : item.enName || item.zhName) || hoverPage == (language == 'zh' ? item.zhName : item.enName || item.zhName)
                      ? colorString.nav.hoverNav
                      : colorString.nav.NavTextCor,
                }"
              >
                <a
                  :href="item.link" target="_blank"
                  >{{ language == 'zh' ? item.zhName : item.enName || item.zhName}}</a
                >
              </li>
              <li
                :class="{ selected: page == language == 'zh' ? item.zhName : item.enName || item.zhName }"
                @click="togger(language == 'zh' ? item.zhName : item.enName || item.zhName)"
                v-if="item.type && item.type == 3"
                @mouseover="hoverPage = (language == 'zh' ? item.zhName : item.enName || item.zhName)"
                @mouseleave="hoverPage = null"
                :style="{
                  background:
                    page == (language == 'zh' ? item.zhName : item.enName || item.zhName) || hoverPage == (language == 'zh' ? item.zhName : item.enName || item.zhName)
                      ? colorString.nav.hoverNav
                      : colorString.nav.NavTextCor,
                }"
              >
                <router-link
                  :style="{
                    color:
                      page == 0 || hoverPage == 1
                        ? colorString.nav.hoverTextCor
                        : colorString.nav.textCor,
                  }"
                  :to="{
                    name: 'contestPage',
                    params: { contestName: contestName },
                    query: { type: index },
                  }"
                  >{{ language == 'zh' ? item.zhName : item.enName || item.zhName}}</router-link
                >
              </li>
              </div> 
              <li
                :class="{ selected: page === 3 }"
                @mouseover="hoverPage = 2"
                @mouseleave="hoverPage = null"
                :style="{
                  background:
                    page == 3 || hoverPage == 2
                      ? colorString.nav.hoverNav
                      : colorString.nav.NavTextCor,
                }"
                @click="togger(3)"
                v-if="matchStatus >= 5 && zhPrizeNoticeCode"
              >
                <router-link
                  :style="{
                    color:
                      page == 3 || hoverPage == 2
                        ? colorString.nav.hoverTextCor
                        : colorString.nav.textCor,
                  }"
                  :to="{
                    name: 'contestAwards',
                    params: { contestName: contestName },
                  }"
                  >{{ $t("global.获奖公示") }}</router-link
                >
              </li>
              <li
                :class="{ selected: page === 2 }"
                @mouseover="hoverPage = 3"
                @mouseleave="hoverPage = null"
                :style="{
                  background:
                    page == 2 || hoverPage == 3
                      ? colorString.nav.hoverNav
                      : colorString.nav.NavTextCor,
                }"
                @click="togger(2)"
                v-if="matchStatus == 4"
              >
                <router-link
                  :style="{
                    color:
                      page == 2 || hoverPage == 3
                        ? colorString.nav.hoverTextCor
                        : colorString.nav.textCor,
                  }"
                  :to="{
                    name: 'shortlistedEntries',
                    params: { contestName: contestName },
                  }"
                  >{{ $t("global.入围作品") }}</router-link
                >
              </li>
              <li
                :class="{ selected: page === 1 }"
                @mouseover="hoverPage = 4"
                @mouseleave="hoverPage = null"
                :style="{
                  background:
                    page == 1 || hoverPage == 4
                      ? colorString.nav.hoverNav
                      : colorString.nav.NavTextCor,
                }"
                @click="togger(1)"
                v-if="matchObject.showProInfo == 1&&workNum > 0"
              >
                <router-link
                  :style="{
                    color:
                      page == 1 || hoverPage == 4
                        ? colorString.nav.hoverTextCor
                        : colorString.nav.textCor,
                  }"
                  :to="{
                    name: 'competitionWorks',
                    params: { contestName: contestName },
                  }"
                >
                  {{ matchObject.id==1064 ? $t("global.sumbitWorks") : $t("global.参赛作品") }}
                  <img
                    class="icon-status"
                    v-if="
                      matchObject.id == 1009 &&
                      new Date() <= new Date('2020/11/10 12:00:00')
                    "
                    :src="
                      language == 'zh'
                        ? '/static/match/images/vote_on_going@2x.png'
                        : '/static/match/images/vote_on_going_en@2x.png'
                    "
                  />
                </router-link>
              </li>
              <li
                :class="{ selected: page === 4 }"
                @mouseover="hoverPage = 5"
                @mouseleave="hoverPage = null"
                :style="{
                  background:
                    page == 4 || hoverPage == 5
                      ? colorString.nav.hoverNav
                      : colorString.nav.NavTextCor,
                }"
                @click="togger(4)"
                v-if="geekList != ''"
              >
                <router-link
                  :style="{
                    color:
                      page == 4 || hoverPage == 5
                        ? colorString.nav.hoverTextCor
                        : colorString.nav.textCor,
                  }"
                  :to="{
                    name: 'information',
                    params: { contestName: contestName },
                  }"
                  >{{ $t("global.赛事资讯") }}</router-link
                >
              </li>
              <li
                class="sigiUp"
                :style="{
                  background:
                    'linear-gradient(270deg,' +
                    colorString.nav.bottonCor1 +
                    '0%,' +
                    colorString.nav.bottonCor2 +
                    '100%',
                }"
                @click="signGoTo"
                v-show="matchStatus == 2"
              >
                <span>{{ $t("global.报名") }}</span>
                <img class="icon-arrow" src="/static/icon_go_submit.png" alt />
              </li>
            </ul>
            <!-- <span class="baroads" @click="signGoTo" v-show="matchObject.status == 1">{{$t('global.立即报名')}}</span> -->
          </div>
          <div
            class="navList1"
            id="navList"
            :style="{ background: colorString.nav.navBg }"
            v-if="(matchStatus !== 1 && matchObject.id == 1031)"
          >
            <ul>
              <li
                :class="{ selected: page === 0 }"
                @mouseover="hoverPage = 1"
                @mouseleave="hoverPage = null"
                :style="{
                  background:
                    page == 0 || hoverPage == 1
                      ? colorString.nav.hoverNav
                      : colorString.nav.NavTextCor,
                }"
                @click="togger(0)"
              >
                <router-link
                  :style="{
                    color:
                      page == 0 || hoverPage == 1
                        ? colorString.nav.hoverTextCor
                        : colorString.nav.textCor,
                  }"
                  :to="{
                    name: 'contestHome',
                    params: { contestName: contestName },
                  }"
                  >{{ $t("global.首页") }}</router-link
                >
              </li>

              <li
                @click="page = 0"
                v-for="(item, index) in language == 'zh' ? tagList : enTagList"
                :key="index"
                v-if="item.text !== '首页'"
                @mouseover="hoverPage = item.id"
                @mouseleave="hoverPage = null"
                :style="{
                  background:
                    hoverPage == item.id
                      ? colorString.nav.hoverNav
                      : colorString.nav.NavTextCor,
                }"
              >
                <a
                  href="javascript:;"
                  @click="scrollPageTo(item.id)"
                  :style="{
                    color:
                      hoverPage == item.id
                        ? colorString.nav.hoverTextCor
                        : colorString.nav.textCor,
                  }"
                  >{{ item.text }}</a
                >
              </li>
              <li
                :class="{ selected: page == item.navName }"
                @click="togger(item.navName)"
                v-if="SubpageList.length"
                v-for="(item, index) in SubpageList"
                :key="index"
                @mouseover="hoverPage = item.navName"
                @mouseleave="hoverPage = null"
                :style="{
                  background:
                    page == item.navName || hoverPage == item.navName
                      ? colorString.nav.hoverNav
                      : colorString.nav.NavTextCor,
                  fontSize:  language == 'zh' ? '24px': '18px',
                }"
              >
                <router-link
                  :style="{
                    color:
                      page == 0 || hoverPage == 1
                        ? colorString.nav.hoverTextCor
                        : colorString.nav.textCor,
                  }"
                  :to="{
                    name: 'contestPage',
                    params: { contestName: contestName },
                    query: { type: index },
                  }"
                  >{{ item.navName }}</router-link
                >
              </li>
              <li
                :class="{ selected: page === 3 }"
                @mouseover="hoverPage = 2"
                @mouseleave="hoverPage = null"
                :style="{
                  background:
                    page == 3 || hoverPage == 2
                      ? colorString.nav.hoverNav
                      : colorString.nav.NavTextCor,
                }"
                @click="togger(3)"
                v-if="matchStatus >= 5 && zhPrizeNoticeCode"
              >
                <router-link
                  :style="{
                    color:
                      page == 3 || hoverPage == 2
                        ? colorString.nav.hoverTextCor
                        : colorString.nav.textCor,
                  }"
                  :to="{
                    name: 'contestAwards',
                    params: { contestName: contestName },
                  }"
                  >{{ $t("global.获奖公示") }}</router-link
                >
              </li>
              <li
                :class="{ selected: page === 4 }"
                @mouseover="hoverPage = 5"
                @mouseleave="hoverPage = null"
                :style="{
                  background:
                    page == 4 || hoverPage == 5
                      ? colorString.nav.hoverNav
                      : colorString.nav.NavTextCor,
                }"
                @click="togger(4)"
                v-if="geekList != ''"
              >
                <router-link
                  :style="{
                    color:
                      page == 4 || hoverPage == 5
                        ? colorString.nav.hoverTextCor
                        : colorString.nav.textCor,
                  }"
                  :to="{
                    name: 'information',
                    params: { contestName: contestName },
                  }"
                  >{{ $t("global.赛事资讯") }}</router-link
                >
              </li>
              <li
                @mouseover="hoverPage = 6"
                @mouseleave="hoverPage = null"
                :style="{
                  background:
                    hoverPage == 6
                      ? colorString.nav.hoverNav
                      : colorString.nav.NavTextCor,
                }"
              style=""
              >
                <router-link to="/article/detail/1648895726582222802" target="_blank" style="color: #fff;"
                  >{{ $t("works.选用公示") }}</router-link
                >
              </li>
              <li
                class="sigiUp"
                :style="{
                  background:
                    'linear-gradient(270deg,' +
                    colorString.nav.bottonCor1 +
                    '0%,' +
                    colorString.nav.bottonCor2 +
                    '100%',
                }"
                @click="signGoTo"
                v-show="matchStatus == 2"
              >
                <span>{{ $t("global.报名") }}</span>
                <img class="icon-arrow" src="/static/icon_go_submit.png" alt />
              </li>
            </ul>
            <!-- <span class="baroads" @click="signGoTo" v-show="matchObject.status == 1">{{$t('global.立即报名')}}</span> -->
          </div>
          <div></div>
        </div>
        <!--view-->
        <div
          class="content-wrap"
          :style="{
            backgroundImage: bgImg
              ? 'url(https://image.manamana.net/' + bgImg + ')'
              : '',
            backgroundColor: bgColor,
          }"
        >
          <div class="container">
            <router-view />
          </div>
        </div>
      </div>
    </div>
    <PerfectInformation
      @closeVisible="step = 0"
      @goToStep="goToNextStep"
      :step="step"
      :matchId="matchObject.id"
      v-if="step !== 0"
      :isInternational="matchObject.matchProperty"
    />
    <share :param="param" :colorString="colorString.share" />
    <div class="popShow" v-if="showText">
      <div class="popBox">
        <div class="title">
          <p class="title1">{{ $t("works.报名须知") }}</p>
          <!-- <span class="title2" @click="closePop"></span> -->
        </div>
        <div v-html="textBody" class="textBody"></div>
        <div class="signupBox">
          <span
            class="upZip"
            @click="gotoSignup1"
            v-if="matchObject.id == 1031 || matchObject.id == 1032 || matchObject.id == 1034"
            >{{ $t("video.下载资源包") }}</span
          ><span @click="showText=false" class="disagree">{{
            $t("global.不同意")
          }}</span>
          <span class="signup" @click="gotoSignup">{{
            $t("global.同意并立即报名")
          }}</span>
          
        </div>
      </div>
    </div>
  </main-layout>
</template>

<script>
import "./css/lifePz.css";
import MainLayout from "@/layouts/MainLayout";
import PerfectInformation from "@/pages/dialog/PerfectInformation";
import share from "@/components/share.vue";
import { imageUrl } from "@/util/filters.js";

export default {
  name: "IndexPage",
  metaInfo() {
    return {
      title: this.$t("global.竞赛") + " | MANA"
    };
  },
  components: {
    MainLayout,
    PerfectInformation,
    share
  },
  data() {
    return {
      contestName: -1,
      /**
       * isInternational:1 $t('global.国际')
       * isInternational:2 $t('global.非国际')
       */
      matchObject: {},
      dialogFormVisible: false,
      step: 0,
      page: 0,
      matchStatus: 0,
      workNum: 0,
      entryWorkNum: 0,
      tagList: [],
      enTagList: [],
      hoverPage: null,
      param: {},
      geekList: [],
      textBody: null,
      showText: false,
      colorString: {
        nav: {
          //导航栏
          navBg: "#333333", //导航条底色
          textCor: "#FFFFFF", //文字颜色,
          hoverTextCor: "#FFFFF", //hover文字颜色
          bottonCor1: "rgba(255, 128, 63, 1)", //报名按钮渐变色1
          bottonCor2: "rgba(255, 78, 38 ,1)", //报名按钮渐变色2
          hoverNav: "#0A0A0A", //hover导航文字底色
          NavTextCor: "#333333" //导航文字底色
        },
        share: {
          //分享
          shareBg: "#999999", //按钮背景色
          topBg: "#E0E0E0", //回到顶部背景色
          iconCor: 0 //icon颜色  0-白色 1-黑色
        },
        works: {
          //作品标签
          worksHoverBg: "#5243FF", //作品标签选择背景颜色
          textCor: "#5243FF" //文字颜色
        },
        page: {
          //导航以下页面背景可配置背景图或颜色
          pageBg: "#f5f5f5", //背景颜色
          pageImg: "" //背景图
        }
      },
      SubpageList: [],
      bgImg: null,
      bgColor: null,
      zhPrizeNoticeCode: null
    };
  },
  created() {
    this.init();
    document.body.style.overflow = "";
  },
  computed: {
    language() {
      return this.$language();
    }
  },
  watch: {
    $route(val) {
      document.documentElement.scrollTop = 0;
      if (val.name !== "contestHome") {
        this.$nextTick(() => {
          setTimeout(() => {
            var targetBox = document.getElementById("navList");
            var targetTop = targetBox.offsetTop;
            document.documentElement.scrollTop = targetTop;
          }, 500);
        });
      }
      if (this.$route.name === "contestPage" || this.$route.name === "contestHome") {
        this.bgImg = this.colorString.page.pageImg;
        this.bgColor = this.colorString.page.pageBg;
      } else {
        this.bgImg = null
        this.bgColor = null
      }
    }
  },
  mounted() {
    if (this.$route.path.indexOf("home") < 0) {
      this.$nextTick(() => {
        setTimeout(() => {
          var targetBox = document.getElementById("navList");
          var targetTop = targetBox.offsetTop;
          document.documentElement.scrollTop = targetTop;
        }, 500);
      });
    }
  },
  methods: {
    togger(page) {
      this.page = page;
    },
    init() {
      this.contestName = this.$route.params.contestName;
      if (this.contestName) {
        this.$http.get("/api/nmatch/url/" + this.contestName).then(response => {
          if (response.code === "OK") {
            this.matchObject = response.data;
            this.buriedPoint(34, this.matchObject.id);
            if (response.data.subjectContentCode) {
              this.colorString = JSON.parse(response.data.subjectContentCode);
            }
            var list =
              response.data.zhPcCustomCode &&
              JSON.parse(response.data.zhPcCustomCode); 
            if (list.length && list[0].type) {
              this.SubpageList = list;
            } else {
              this.SubpageList =
                this.language === "zh"
                  ? response.data.zhPcCustomCode &&
                    JSON.parse(response.data.zhPcCustomCode)
                  : (response.data.enPcCustomCode &&
                      JSON.parse(response.data.enPcCustomCode)) ||
                    (response.data.zhPcCustomCode &&
                      JSON.parse(response.data.zhPcCustomCode));
            }
            this.geekList =
              this.language === "zh"
                ? response.data.zhMatchAdCode &&
                  JSON.parse(response.data.zhMatchAdCode)
                : response.data.enMatchAdCode &&
                  JSON.parse(response.data.enMatchAdCode);
            this.zhPrizeNoticeCode = response.data.zhPrizeNoticeCode;
            // this.matchStatus = this.getMatchStatus(this.matchObject);
            this.page =
              this.$route.name === "shortlistedEntries"
                ? 2
                : this.$route.name === "competitionWorks"
                  ? 1
                  : this.$route.name === "contestHome"
                    ? 0
                    : this.$route.name === "contestAwards"
                      ? 3
                      : this.$route.name === "information"
                        ? 4
                        : this.$route.name === "contestPage"
                          ? this.SubpageList[this.$route.query.type].navName
                          : 0;
            if (this.$route.name === "contestHome" || this.$route.name === "contestPage") {
              this.bgImg = this.colorString.page.pageImg;
              this.bgColor = this.colorString.page.pageBg;
            } 
            this.matchStatus = response.data.matchState;
            document.title = response.data.title;
            this.param = {
              title: response.data.title + " | MANA",
              url: window.location.href,
              pic: imageUrl(response.data.wechatImage)
            };
            //不显示参赛作品
            if (this.matchObject.id !== 1036) {
              this.gethomeVideolist();
            }
            this.getEntryVideolist();

            this.tagList =
              response.data.zhContentCode &&
              JSON.parse(response.data.zhContentCode);
            this.enTagList =
              response.data.enContentCode &&
              JSON.parse(response.data.enContentCode);
          }
        });
      }
    },
    getMatchStatus(item) {
      return Date.now() >= item.startTime && Date.now() < item.endTime
        ? 1 //$t('global.投稿中')
        : Date.now() >= item.endTime && Date.now() < item.publishStartTime
          ? 2 //$t('global.评审中')
          : Date.now() >= item.publishStartTime && Date.now() < item.overTime
            ? 3 //公布结果
            : Date.now() >= item.overTime
              ? 4 //$t('global.结束')
              : null;
    },
    scrollPageTo(id) {
      document.documentElement.scrollTop = 0;
      if (this.$route.path.indexOf("home") < 0) {
        this.$router.push(`/match/${this.contestName}/home`);
        var interval = setInterval(function() {
          if (document.getElementById(id)) {
            document.getElementById(id).scrollIntoView(true);
            clearInterval(interval);
          }
        }, 500);
      } else {
        document.getElementById(id).scrollIntoView(true);
      }

      return false;
    },
    gotoSignup() {
      this.$router.push(`/match/${this.contestName}/enter`);
      document.body.style.overflow = "";
    },
    gotoSignup1() {
      if (this.matchObject.id == 1034) {
        let a = document.createElement("a"); // 创建a标签
        let e = document.createEvent("MouseEvents"); // 创建鼠标事件对象
        e.initEvent("click", false, false); // 初始化事件对象
        a.href =
          "https://file.manamana.net/About%20the%20Model%20%E6%A8%A1%E5%9E%8B%E4%BF%A1%E6%81%AF.zip"; // 设置下载地址
        a.download = ""; // 设置下载文件名
        a.dispatchEvent(e);
      } else {
        this.$router.push(`/match/${this.contestName}/enter?name=jinjiang`);
        document.body.style.overflow = "";
      }
    },
    closePop() {
      this.showText = false;
      document.body.style.overflow = "";
    },
    signGoTo() {
      const peopleMessage = this.$store.state.peopleMessage;
      if (!peopleMessage) {
        this.$router.push(`/login?redirecturl=${location.href}`);
        return;
      }
      if (this.matchObject.adInfoId) {
        this.$http
          .get("/api/common/page", {
            params: {
              id: this.matchObject.adInfoId
            }
          })
          .then(res => {
            if (res.code == "OK") {
              this.textBody = res.data.body;
              this.showText = true;
              document.body.style.overflow = "hidden";
            }
          });
      } else {
        this.$router.push(`/match/${this.contestName}/enter`);
      }
      // if (
      //   peopleMessage.name &&
      //   peopleMessage.phone &&
      //   peopleMessage.email &&
      //   peopleMessage.nationality &&
      //   peopleMessage.introduce
      // ) {
      //   if (this.matchObject.isInternational == 1 && !peopleMessage.introduce) {
      //     this.step = 1;
      //   } else {
      //     this.step = 2;
      //   }
      // } else {
      //   this.step = 1;
      // }
    },
    goToNextStep(choosedType) {
      if (this.step === 1) {
        this.step = 2;
      } else if (this.step === 2) {
        if (choosedType === 1) {
          this.$router.push(`/UpVideo?matchId=${this.matchObject.id}`);
        } else {
          this.step = 3;
        }
      }
    },
    gethomeVideolist() {
      let $this = this;
      this.$http
        .get("/api/match/video/list2", {
          params: {
            pageIndex: 1,
            pageSize: 1,
            matchId: this.matchObject.id
          }
        })
        .then(function(response) {
          $this.workNum = response.data.totalRecord;
        });
    },
    getEntryVideolist() {
      let $this = this;
      this.$http
        .get("/api/match/video/list", {
          params: {
            pageIndex: 1,
            pageSize: 1,
            matchId: this.matchObject.id,
            status: 5
          }
        })
        .then(function(response) {
          $this.entryWorkNum = response.data.totalRecord;
        });
    }
  }
};
</script>
<style lang="stylus" scoped>
.contest-wrap {
  min-width: 1280px;
  overflow: hidden;
  position: relative;
  background-color: #f5f5f5;
}

.geekBanner .do-banner1 {
  width: 100%;
  height: auto;
  overflow: hidden;
  display: flex;
  justify-content: center;
}

.geekBanner .do-banner1 img {
  display: block;
  max-width: 2880px;
}

.navList {
  position: relative;
  height: 70px;
  clear: both;
}

.navList1 {
  position: relative;
  height: 140px;
  clear: both;
}

.navList ul {
  display: flex;
  flex-direction: row;
  align-items: center;
  height: 70px;
  /* width: 880px;
  margin: 0 auto; */
  position: absolute;
  left: 50%;
  -webkit-transform: translate(-50%);
  -moz-transform: translate(-50%);
  transform: translate(-50%);
}

.navList1 ul {
  height: 140px;
  position: absolute;
  left: 50%;
  -webkit-transform: translate(-50%);
  -moz-transform: translate(-50%);
  transform: translate(-50%);
  width: 960px;
  font-size: 0;
}

.navList ul li {
  position: relative;
  font-size: 24px;
  font-family: PingFangSC-Semibold;
  line-height: 70px;
  min-width: 172px;
  white-space: nowrap;
  padding: 0 24px !important;
  text-align: center;
  cursor: pointer;
  border-left: 1px solid rgba(255, 255, 255, 0.2);
  border-right: 1px solid rgba(255, 255, 255, 0.2);
}

.navList1 ul li {
  float: left;
  font-size: 24px;
  line-height: 70px;
  height: 70px;
  width: 240px;
  box-sizing: border-box;
  text-align: center;
  cursor: pointer;
  border-left: 1px solid rgba(255, 255, 255, 0.2);
  border-bottom: 1px solid rgba(255, 255, 255, 0.2);
  &:nth-child(4) {
    border-right: 1px solid rgba(255, 255, 255, 0.2);
  }
  &:nth-child(8) {
    border-right: 1px solid rgba(255, 255, 255, 0.2);
  }
}
.navList1 ul li a{
  width: 100%;
  height: 100%;
  display: inline-block;
}
.navList ul li .icon-status {
  position: absolute;
  top: 8px;
  right: 8px;
  width: 62px;
  height: 22px;
}

.navList ul li .icon-arrow {
  width: 30px;
  height: 30px;
  margin-left: 10px;
  vertical-align: sub;
}

.navList1 ul li .icon-arrow {
  width: 30px;
  height: 30px;
  margin-left: 10px;
  vertical-align: sub;
}

.navList ul li a {
  font-family: PingFangSC-Regular;
  font-weight: bold;
  color: #fff;
  font-weight: bold;
  display: inline-block;
  width: 100%;
  height: 100%;
}

/* .navList ul li.selected {
  background: #5243FF;
}
.navList ul li:hover{
  background: #5243FF;
} */
/* .navList ul li.sigiUp {
  background: linear-gradient(
    270deg,
    rgba(255, 128, 63, 1) 0%,
    rgba(240, 21, 38, 1) 100%
  );
} */
.navList ul li.sigiUp span {
  color: #fff;
}
.navList1 ul li.sigiUp span {
  color: #fff;
}
.navList ul li.selected a {
  color: #fff;
}

.navList .baroads {
  left: 50%;
  top: 40px;
  position: absolute;
  display: inline-block;
  width: 165px;
  height: 40px;
  margin-left: 415px;
  color: #fff;
  z-index: 99;
  cursor: pointer;
  font-size: 14px;
  border-radius: 10px;
  text-align: center;
  line-height: 40px;
  background: #ff6363;
  font-weight: bold;
  font-size: 20px;
}

.content-wrap {
  // padding-top: 50px;
  background-repeat: repeat-y;
  background-position: top center;
  margin: 0 auto;
}

.container {
  width: 1440px;
  margin: 0 auto;
  padding-bottom: 20px;
}

.popShow {
  position: fixed;
  top: 0;
  left: 0;
  width: 100vw;
  height: 100vh;
  background: rgba(0, 0, 0, 0.7);
  z-index: 1000;

  .popBox {
    width: 730px;
    padding-bottom: 20px;
    background: #FFFFFF;
    position: absolute;
    left: 50%;
    top: 50%;
    transform: translate(-50%, -50%);

    .title {
      height: 60px;
      line-height: 60px;
      border-bottom: 1px solid #E0E0E0;
      padding: 0 30px;
      position: relative;

      .title1 {
        font-size: 18px;
        font-weight: 600;
        color: #0A0A0A;
      }

      .title2 {
        position: absolute;
        right: 30px;
        background: url('/static/close_btn@2x.png');
        background-size: 100%;
        width: 13px;
        height: 13px;
        top: 23px;
        cursor: pointer;
      }
    }

    .textBody {
      padding: 20px;
      height: 65vh;
      overflow: scroll;
      font-size: 14px;
      line-height: 28px;
    }

    .signupBox {
      width: 100%;
      text-align: center;
      margin-top: 20px;

      .upZip {
        display: inline-block;
        width: 144px;
        height: 40px;
        line-height: 40px;
        text-align: center;
        background: #2026CC;
        font-size: 16px;
        font-weight: 500;
        color: #FFFFFF;
        cursor: pointer;
        margin-right: 20px;
      }
      .disagree {
        display: inline-block;
        width: 142px;
        height: 38px;
        line-height: 40px;
        text-align: center;
        border: solid 1px #2026CC;
        color: #2026CC;
        font-size: 16px;
        font-weight: 500;
        cursor: pointer;
        margin-right: 20px;
        overflow: hidden;
      }
      .signup {
        display: inline-block;
        width: 144px;
        height: 40px;
        line-height: 40px;
        text-align: center;
        background: #2026CC;
        font-size: 16px;
        font-weight: 500;
        color: #FFFFFF;
        cursor: pointer;
        overflow: hidden;
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/pages/match/Contest.vue